import { InputErrorContainer } from '../../error/containers/input-error.container';
import { InputLabelContainer } from '../../label/containers/input-label.container';
import React from 'react';

export function TextInputComponent({
  label,
  icon: Icon,
  placeholder,
  name,
  value,
  onValueChange,
  isDisabled,
  error,
  isErrored,
  type,
  step,
  min,
  max,
  adornmentPosition = 'end',
  noMargin,
  onClick,
  isRequired,
  className
}: any) {


  return (
    <div className={`mb-3 ${noMargin ? '' : 'input-wrapper-overrider'}`} onClick={(event) => onClick && onClick(event)}>
      <InputLabelContainer
        isRequired={isRequired}
        label={label}
      />

      <div>
        {Icon && adornmentPosition === 'start' && (
          <span className="absolute left-0 top-0 mt-2 ml-2">
            <Icon />
          </span>
        )}
        <input
          className={className ? className : `appearance-none block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
            } ${Boolean(error) || isErrored ? 'border-red-500' : ''}`}
          disabled={isDisabled}
          name={name}
          onChange={onValueChange}
          placeholder={placeholder}
          type={type || 'text'}
          value={value}
          step={step}
          min={min}
          max={max}
        />
        {Icon && adornmentPosition === 'end' && (
          <span className="absolute right-0 top-0 mt-2 mr-2">
            <Icon />
          </span>
        )}
      </div>

      <InputErrorContainer error={error} />
    </div>
  );
}